import { Component, DoCheck, HostListener, OnInit } from '@angular/core';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { ActivatedRoute, Router } from '@angular/router';
import { SettingsService } from '../../service/settings.service';
import { MatDialog } from '@angular/material/dialog';
import { FormBuilder, FormGroup } from '@angular/forms';
import { IChildPageLinkOption, TabState, IWidgetAnchorOption, buildNestedIdMap, changeComposeNodeId, chatWidgetData, composedWidgetData, deepCleanTranslations, defaultColorsValues, defaultColorsValuesDark, defaultWidgets, duplicateWidgetData, getNextChildName, getTime, oneClickPayWidgetData, pickWidgetTranslations, processObjectRecursively, productRegistrationWidgetData, renameTranslationKeys, setNestedValue, toDate, transformTranslationKey, widgetEditMode, widgetsMenuDPP } from 'na-lib';
import { CommentsService } from '../../service/comments.service';
import { PassDefinitionsService } from '../../service/pass-definitions.service';
import { LocalStorageService } from '../../service/local-storage-service.service';
import { deepCopy, makeid, removeUndefined, removeUndefinedValuesFromObject, deleteOldWidgetTranslations, languagesList, languagesList_, isDateTimeGetTimeSeconds, widgetTypes,ContentType, Template } from 'na-lib';
import { UploadService } from '../../service/upload.service';
import { TranslateService } from '@ngx-translate/core';
import { ContentTypeService } from '../../service/content-type.service';
import { QrCodeDialogComponent } from '../../qr-code-dialog/qr-code-dialog.component';
import { CancelChangesDialogComponent } from '../../cancel-changes-dialog/cancel-changes-dialog.component';
import { BehaviorSubject, Observable } from 'rxjs';
import { TridysService } from '../../service/tridys.service';
import { UpdateConfirmationDialogComponent } from '../../update-confirmation-dialog/update-confirmation-dialog.component';
import { Model3dEditComponent } from '../../widgets/editWidgets/model3d-edit/model3d-edit.component';
import { ProductsEditComponent } from '../../widgets/editWidgets/products-edit/products-edit.component';
import { SpacerEditComponent } from '../../widgets/editWidgets/spacer-edit/spacer-edit.component';
import { ChatEditComponent } from '../../widgets/editWidgets/chat-edit/chat-edit.component';
import { ListEditComponent } from '../../widgets/editWidgets/list-edit/list-edit.component';
import { CanComponentDeactivate } from '../../can-deactivate/can-deactivate.guard';
import { PassTemplatesThemeEditComponent } from '../pass-templates-theme-edit/pass-templates-theme-edit.component';
import { PassTemplatesSettingsEditComponent } from '../pass-templates-settings-edit/pass-templates-settings-edit.component';
import { TranslationsDPPService } from '../../service/translations-dpp.service';
import { deleteField } from '@angular/fire/firestore';
import { Functions, httpsCallable } from "@angular/fire/functions";
import { OneclickpayEditComponent } from 'src/app/widgets/editWidgets/oneclickpay-edit/oneclickpay-edit.component';
import { FreePublisherInfoDialogComponent } from 'src/app/free-publisher-info-dialog/free-publisher-info-dialog.component';
import { WidgetEditDialogComponent } from 'src/app/widgets/widget-edit-dialog/widget-edit-dialog.component';
import { Storage } from '@angular/fire/storage';
import { WidgetClipboardService } from '../../service/widget-clipboard.service';
import { DppThemeService } from 'src/app/service/dpp-theme.service';
import { ReaderDocument } from '@narravero/web-reader-lib';
import { buildReaderDocument } from './build-reader-document';
import { getButtonColorDefaults } from '../../shared/utils';

@Component({
    selector: 'app-pass-templates',
    templateUrl: './pass-templates.component.html',
    styleUrls: ['./pass-templates.component.css'],
    standalone: false
})

export class PassTemplatesComponent implements OnInit, DoCheck, CanComponentDeactivate {

  readerDocument: ReaderDocument | null = null;
  private readerDocumentSignature = '';

  // allWidgets/themeData are mutated in place all over the editor, so rebuild the preview
  // document only when their serialized content actually changes
  ngDoCheck(): void {
    const mediaContext = { passId: this.idToShow, contextId: this.settingsService.contextId$ };
    const signature = JSON.stringify([this.allWidgets, this.themeData, this.languageSelected, mediaContext]);
    if (signature === this.readerDocumentSignature) return;
    this.readerDocumentSignature = signature;
    this.readerDocument = buildReaderDocument(this.allWidgets, this.themeData, this.languageSelected, mediaContext);
  }

  phoneFullHeightView = false;
  darkMode = false;
  passTemplateLanguages:any = []
  passTemplateLanguagesO:any = {}
  oldTemplateData:any
  oldChildTemplateData:any = {}
  widgetsNames = widgetTypes
  editTemp=true
  data:any
  templateData:any
  translationDisabled:boolean
  all:any
  widgetsTypes:any= []
  disableProductRegistration = false
  alltemplates:any=[]
  currentRoute:any
  themeData:Template
  idToShow:any
  routerUrl:any
  allWidgets:any=[]
  translationMode = false
  idsList:any=[]
  idValue:any = 0
  activeLanguage:any
  passDefaultLanguage:string
  selectedWidgetId: string | null = null;
  isDialogEditOpen: boolean = false;
  dppLanguagesChanges$: BehaviorSubject<string[]> = new BehaviorSubject<string[]>([])

  /* CHILD DPP */
  tabs: TabState[] = [];
  activeTabId: string = 'main';
  currentMenuTab: TabState | null = null;
  mainTabLabel = 'Main';

  get activeTab(): TabState { return this.tabs.find(t => t.id === this.activeTabId)!; }

  get selectedTabIndex(): number {
    const idx = this.tabs.findIndex(t => t.id === this.activeTabId);
    return idx >= 0 ? idx : 0;
  }

  get widgetAnchorOptions(): IWidgetAnchorOption[] {
    return (this.allWidgets || [])
      .filter(w => w && w.id)
      .map((w, index) => {
        const typeLabel = this.widgetsNames[w.type] || w.type;
        const name = w.name || `${typeLabel} ${this.checkTypeNumber(w, index)}`;

        return { id: w.id, label: name, type: w.type };
      });
  }

  get childPageLinkOptions(): IChildPageLinkOption[] {
    return (this.tabs || []).map(t => ({
      id: t.id,
      name: t.isMain
        ? (this.translate.instant('pass.mainTabLabel') || 'Main page')
        : (t.name || 'Child'),
      isMain: t.isMain,
    }));
  }

  onSelectedIndexChange(index: number): void {
    const tab = this.tabs[index];
    if (tab) this.setActiveTab(tab.id);
  }

  onTabMenuButtonClick(tab: TabState, event: MouseEvent): void {
    event.stopPropagation();
    event.preventDefault();
    this.currentMenuTab = tab;
  }

  renameCurrentTab(): void {
    if (!this.currentMenuTab || this.currentMenuTab.isMain) return;

    const newName = window.prompt(
      this.translate.instant('pass.renameTabPrompt') || 'Rename tab',
      this.currentMenuTab.name
    );
    if (!newName) return;

    this.currentMenuTab.name = newName.trim();
    this.changesToSave = true;
  }

  deleteTab(tabId?: string, event?: MouseEvent): void {
    if (!tabId) return;
    event?.stopPropagation();
    event?.preventDefault();

    const index = this.tabs.findIndex(t => t.id === tabId);
    if (index === -1) return;
    const tab = this.tabs[index];

    // Never delete main
    if (tab.isMain) return;

    const wasActive = this.activeTabId === tabId;
    this.tabs.splice(index, 1);
    delete this.oldChildTemplateData[tabId]
    if (wasActive && this.tabs.length > 0) {
      const newIndex = Math.max(index - 1, 0);
      const newActive = this.tabs[newIndex];
      if (newActive)  this.setActiveTab(newActive.id);
    }

    this.currentMenuTab = null;
    this.changesToSave = true;
  }

  duplicateTab(tabId?: string, event?: MouseEvent): void {
    if (!tabId) return;
    event?.stopPropagation();
    event?.preventDefault();

    const index = this.tabs.findIndex(t => t.id === tabId);
    if (index === -1) return;
    const tab = this.tabs[index];
    // Never duplicate main
    if (tab.isMain) return;

    const newTab = deepCopy(tab)
    const newId = makeid(20);
    newTab.id = newId
    newTab.name = newTab.name +'_copy'
    newTab.enableShoppingCart = false
    newTab.enableCustomerLogin = false
    newTab.main = false
    newTab.creationDate = new Date()

    let translations = newTab.translations
    newTab.widgets.forEach((widget) => {
      const { newTranslations, newWidget, oldId} = duplicateWidgetData(widget, translations )
      translations = newTranslations
      translations = deleteOldWidgetTranslations(translations, oldId)
      widget.id = newWidget.id
    });

    newTab.translations = translations

    this.tabs.push(newTab);
    this.oldChildTemplateData[newTab.id] = newTab
    this.sortTabsByCreationDate();
    this.setActiveTab(newId);
    this.changesToSave = true;
  }

  setActiveTab(tabId: string): void {
    if (this.activeTabId === tabId) return;

    const current = this.tabs.find(t => t.id === this.activeTabId);
    if (current) {
      const v = this.templateForm.value;
      current.widgets = deepCopy(v.widgets || []);
      current.translations = deepCopy(v.translations || {});
      current.languages = deepCopy(v.languages || []);
      
      if (current.isMain) current.name = v.name || current.name;

      current.enableShoppingCart = !!v.enableShoppingCart;
      current.enableCustomerLogin = !!v.enableCustomerLogin;
    }

    this.activeTabId = tabId;
    const t = this.tabs.find(tt => tt.id === tabId);
    if (!t) return;

    this.allWidgets = deepCopy(t.widgets || []);

    const patch: any = {
      widgets: t.widgets,
      translations: t.translations,
      languages: this.dppLanguagesChanges$.getValue(),
      enableShoppingCart: t.enableShoppingCart,
      enableCustomerLogin: t.enableCustomerLogin
    };

    if (t.isMain) patch.name = t.name;

    this.templateForm.patchValue(patch, { emitEvent: false });

    this.idsList = [];
    this.allWidgets.forEach(w => {
      if (w && w.id)
        this.idsList.push(w.id);
      else if (w) {
        const newId = makeid(6);
        w.id = newId;
        this.idsList.push(newId);
      }
    });

    this.passLanguages = deepCopy(t.languages || []);
    this.languagesPassList = deepCopy(this.passLanguages);
    this.languageSelected = this.passLanguages[0] || this.contextFirstLanguage;
    this.passDefaultLanguage = this.languageSelected;
    this.dppTranslations.setDefaultLanguagePass(this.passDefaultLanguage);

    this.checkTranslationAvailability();
  }

  private async loadChildTabs(loadDraft = this.hasDraft): Promise<void> {
    try {
      if (!this.templateData || !this.templateData.id) return;

      const passId = this.templateData.id;
      const children = loadDraft
        ? await this.passDefinitionService.getPassDraftChildren(passId)
        : await this.passDefinitionService.getPassChildren(passId);

      this.oldChildTemplateData = {};
      children.forEach((c) => {
        const existingChildCount = this.tabs.filter(t => !t.isMain).length;
        const hasName = c.name !== undefined &&
                        c.name !== null &&
                        (typeof c.name !== 'string' || c.name.trim().length > 0);

        const defaultName = this.translate.instant('pass.childTabDefaultName', { index: existingChildCount + 1 }) || `Child ${existingChildCount + 1}`;

        const tab: TabState = {
          id: c.id,
          isMain: false,
          name: hasName ? c.name : defaultName,
          widgets: deepCopy(c.widgets || []),
          translations: deepCopy(c.translations || {}),
          languages: deepCopy(c.languages || []),
          enableShoppingCart: !!c.enableShoppingCart,
          enableCustomerLogin: !!c.enableCustomerLogin,
          creationDate: toDate(c.creationDate) ?? new Date(),
        };

        this.oldChildTemplateData[c.id] = tab
        this.tabs.push(tab);
      });
      this.sortTabsByCreationDate();
      this.renameTabs();
    } catch (error) {
      console.log('[loadChildTabs] error', error);
    }
  }

  private sortTabsByCreationDate(): void {
    if (!this.tabs?.length) return;

    const main = this.tabs.find(t => t.isMain) ?? this.tabs[0];

    const children = this.tabs
      .filter(t => !t.isMain)
      .sort((a, b) => {
        const aTime = getTime(a.creationDate);
        const bTime = getTime(b.creationDate);
        return aTime - bTime; 
      });

    this.tabs = [main, ...children];
  }

  private renameTabs(): void {
    if (!this.tabs || this.tabs.length === 0) return;
    const main = this.tabs[0];
    main.isMain = true;
  }

  addChildTab() {
    const childTabLabel = this.translate.instant('pass.childTabLabel')
    const newId = makeid(20);
    const newTab: TabState = {
      id: newId,
      isMain: false,
      name: getNextChildName(this.tabs, childTabLabel),
      widgets: [],
      translations: {},
      languages: deepCopy(this.passLanguages || []),
      enableShoppingCart: false,
      enableCustomerLogin: false,
      creationDate: new Date(),
    };

    this.tabs.push(newTab);
    this.oldChildTemplateData[newId] = newTab
    this.sortTabsByCreationDate();
    this.setActiveTab(newId);

    this.changesToSave = true;
  }

  /* END CHILD DPP */

  widgetsMenu = widgetsMenuDPP
  imagesToUpload=[]
  widgetsForm!:FormGroup
  themeForm!:FormGroup
  templateForm!:FormGroup
  name:any//template name for locastorage: Template-{{id}}
  contextLanguages:any=[]
  contextFirstLanguage:any
  passLanguages:any=[]
  passFirstLanguage:any
  languagesList = languagesList
  languageSelected:any
  langaugeSwitcher=false
  urlFonts:any = {}
  defaultColorsValues = defaultColorsValues
  defaultColorsValuesDark = defaultColorsValuesDark
  languagesPassList:any
  translations:any
  settingsPass:any
  showTranslation=false
  contentTypeId:any
  contentType:any
  oldContentType:any
  unexistingPass=false
  changesToSave=false
  changesCanceled=false
  hasDraft=false
  draftLoaded=false
  draftId: string | undefined;
  userHasBetaWidgetRole = false
  tridyCount: any
  titleEdit:any
  contextLicenseFree = false

  constructor(
    private router: ActivatedRoute,
    private route: Router,
    public dialog: MatDialog,
    private passDefinitionService: PassDefinitionsService,
    public localStorageService: LocalStorageService,
    private settingsService: SettingsService,
    private contentTypeService: ContentTypeService,
    private uploadService: UploadService,
    private fb: FormBuilder,
    private commentService: CommentsService,
    private tridyService: TridysService,
    private translate:TranslateService,
    private functions: Functions,
    private dppTranslations: TranslationsDPPService,
    private widgetClipboardService: WidgetClipboardService,
    private storage: Storage,
    private dppThemeService: DppThemeService
  ){

    this.routerUrl=this.router.url
    this.idToShow=this.routerUrl.value[this.routerUrl.value.length-1].path
    this.dppThemeService.setIdToShow(this.idToShow)
    this.contentTypeId = this.routerUrl.value[this.routerUrl.value.length-3].path
    this.currentRoute=this.routerUrl.value[0].path

    const currentLang = this.translate.currentLang() ?? 'en';
    this.languagesList = deepCopy(languagesList_[currentLang])

    this.translate.onLangChange.subscribe( value => {
      const currentLang = value.lang;
      this.languagesList = deepCopy(languagesList_[currentLang])
    })
  }

  // add guard to avoid loss of unsaved changes

  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    if (this.changesToSave) {
      const cancel =  this.openCancelChangesDialog();
      cancel.subscribe(value => {
        if(value){
          this.dppThemeService.colorsToDefault()
          this.dppThemeService.restoreFonts()
        }
      })
      return cancel
    } else {
      return true; // Allow navigation if no changes
    }
  }

  private openCancelChangesDialog(): Observable<boolean> {
    const dialogRef = this.dialog.open(CancelChangesDialogComponent, { data: 'passTemplate' });
    return dialogRef.afterClosed();
  }

  async ngOnInit(): Promise<void> {

    this.settingsService.contextLicenseFreePublisher$.subscribe( value => this.contextLicenseFree = value)
    this.dppThemeService.colorsToDefault()
    this.dppThemeService.fontsToDefault()
    if(this.settingsService.checkIfBetaRoleAccess()){
      this.userHasBetaWidgetRole = true

      const composed = composedWidgetData
      const chat = chatWidgetData
      const productRegistration = productRegistrationWidgetData
      const oneClickPay = oneClickPayWidgetData

      if(!this.widgetsMenu.some( (w:any) => w.type === composed.type))
      this.widgetsMenu.push(composed)
      //this.widgetsMenu.push(lists)
      if(!this.widgetsMenu.some( (w:any) => w.type === productRegistration.type))
      this.widgetsMenu.push(productRegistration)

      if(!this.widgetsMenu.some( (w:any) => w.type === chat.type))
      this.widgetsMenu.push(chat)

      if(!this.widgetsMenu.some( (w:any) => w.type === oneClickPay.type))
      this.widgetsMenu.push(oneClickPay)
    }

    // Stop reload event if there are unsaved changes
    window.onbeforeunload = (event) => {
      if (this.changesToSave && !this.changesCanceled) {
        // Display a confirmation message
        event.returnValue = 'You have unsaved changes. Are you sure you want to leave?';
      }
    };

    this.templateData = new Template()
    this.alltemplates=this.settingsService.settingsPassDefinitionsWithId
    this.getContentTypeId()

    this.contextLanguages = deepCopy(this.settingsService.languagesContexts$)
    this.languagesPassList = deepCopy(this.contextLanguages)
    this.contextFirstLanguage = this.settingsService.firstLanguageContexts$

    if(this.contextFirstLanguage){
      this.languageSelected = this.contextFirstLanguage
      this.passDefaultLanguage = this.contextFirstLanguage
      this.dppTranslations.setDefaultLanguagePass(this.passDefaultLanguage)
    }

    if(this.settingsService.languagesContexts$)
      this.langaugeSwitcher = true

    try {
      this.commentService.progressSpin.emit(true);

      const value = await this.settingsService.getPassDefinitionId(this.idToShow);
      const draftValue = value ? await this.passDefinitionService.getPassDefinitionDraft(this.idToShow) : false;
      const valueToEdit = draftValue || value;
      this.hasDraft = !!draftValue;
      this.draftLoaded = !!draftValue;
      this.draftId = draftValue?.draftId || draftValue?.id || this.idToShow;
      this.settingsPass = valueToEdit;

      if (valueToEdit) {
        this.templateData = new Template();
        this.templateData.setFromAny(valueToEdit);

        if (this.templateData) {
          this.passTemplateLanguages.push(this.templateData);
          this.passTemplateLanguagesO['default'] = deepCopy(this.templateData);
          const oldTemplate = this.templateData;
          this.oldTemplateData = deepCopy(oldTemplate);

          if (this.templateData.theme) 
            this.themeData = this.templateData.theme;

          if (this.templateData.translations) {
            this.translations = deepCopy(this.templateData.translations);
            this.dppTranslations.initializePassTranslatedValues(this.translations);
          }

          if (this.templateData.widgets) {
            this.templateData.widgets.forEach((element: any) => {
              this.widgetsTypes.push(element.type);
            });
          }

          if (this.templateData.languages) {
            this.passLanguages = deepCopy(this.templateData.languages);
            this.languagesPassList = deepCopy(this.passLanguages);

            this.dppTranslations.initializePassLanguages(this.passLanguages);
            this.dppLanguagesChanges$.next(this.passLanguages)

            if (this.templateData.languages.length > 0) {
              this.passFirstLanguage = this.templateData.languages[0];
              this.passDefaultLanguage = this.passFirstLanguage;
              this.dppTranslations.setDefaultLanguagePass(this.passDefaultLanguage);

              if (this.passFirstLanguage)
                this.languageSelected = this.passFirstLanguage;

              this.langaugeSwitcher = true;
            } else {
              this.langaugeSwitcher = false;
            }
          }

          this.editTemplate();
        }

        const oldTemplate = this.templateData;
        this.oldTemplateData = deepCopy(oldTemplate);
      } else {
        this.unexistingPass = true;
        const data = {
          name: this.contentType.displayName,
          widgets: [],
          contextId: this.settingsService.contextId$,
          id: this.idToShow,
        };

        this.templateData = new Template();
        this.templateData.setFromAny(data);

        if (this.templateData) {
          this.passTemplateLanguages.push(this.templateData);
          this.passTemplateLanguagesO['default'] = deepCopy(this.templateData);
          const oldTemplate = this.templateData;
          this.oldTemplateData = deepCopy(oldTemplate);

          if (this.templateData.widgets) {
            this.templateData.widgets.forEach((element: any) => {
              this.widgetsTypes.push(element.type);
            });
          }

          this.editTemplate();
        }

        const oldTemplate = this.templateData;
        this.oldTemplateData = deepCopy(oldTemplate);
      }

      await this.loadChildTabs(this.hasDraft);

      this.dppThemeService.updateColors(this.themeData);
      this.dppThemeService.updateColorsDark(this.themeData)
      this.dppThemeService.updateFonts(this.themeData)
    } catch (error) {
      console.log(error);
    } finally {
      this.commentService.progressSpin.emit(false);
    }

    ///// CREATE TRIDY ON INIT ///////
    const tridyContent = {
      contentType: this.idToShow,
      contextId: this.settingsService.contextId$
    }

    if(this.contentTypeId){
      try{
        this.tridyService.createTridyFromContentType(tridyContent, this.contentTypeId)
      }catch(error){
        console.log(error)
      }
      //-------do not delete this----------------------------------------------------------------------
      //uncomment this to show the warning message: this pass has x tridys, are you sure you want to update?
      // this.countTridysPass()
    }

    if(this.darkMode)
      this.dppThemeService.setColorsToDark(this.themeData)
    else
      this.dppThemeService.setColorsToLight(this.themeData)

    this.checkTranslationAvailability()

    if (this.templateData.widgets && this.templateData.widgets.some(widget => widget.type === 'productRegistration'))
      this.disableProductRegistration = true

    this.clearSelection();
    this.isDialogEditOpen = false;
  }

  get checkLicenseFree(): boolean{ return this.contextLicenseFree ? true : false }

  checkTranslationAvailability(){
    if(this.passLanguages && this.passLanguages.length>1){
      this.translationDisabled = false
    }else{
      if(!this.passLanguages || this.passLanguages.length ==0 ){
        if(this.contextLanguages && this.contextLanguages.length>1)
          this.translationDisabled = false
        if(!this.contextLanguages){
          this.translationDisabled = true
        }
        if(this.contextLanguages && this.contextLanguages.length==1){
          this.translationDisabled = true
        }
      }
      if(this.passLanguages && this.passLanguages.length==1){
        this.translationDisabled = true
      }

      if(this.passLanguages && this.passLanguages.length==0 && this.contextLanguages && this.contextLanguages.length ==0 ){
        this.translationDisabled = true
      }
    }
  }

  async getContentTypeId(){
    try{
      this.commentService.progressSpin.emit(true)
      this.contentType = await this.settingsService.observeContextsContentTypesIdFirestore(this.contentTypeId)
      if(this.contentType.displayName)
      this.titleEdit = this.contentType.displayName

      this.oldContentType = new ContentType()
      this.oldContentType.setFromAny(this.contentType)

      this.commentService.progressSpin.emit(false)

    }catch(error){
      console.log(error)
      this.commentService.progressSpin.emit(false)
      const message = this.translate.instant("SnackBarConstants.LOAD_FAILED")
      this.commentService.addSnackBar.emit(message)
    }
  }

  initializeForms(){
    this.idsList=[]
    this.widgetsForm = this.fb.group({})

    if(this.templateData && this.templateData.widgets){
      this.templateData.widgets.forEach((w, index)=>{
        this.widgetsForm.value[index]=w
        this.allWidgets.push(w)
        this.idsList.push(w.id)
      })
    }

    const {id, contextId, theme, comment, name, templateName, contentType, customer, tridyId, widgets, translations,languages,enableShoppingCart,enableCustomerLogin} = this.templateData
    this.templateForm = this.fb.group({
      contextId: [{value: contextId ? contextId : undefined, disabled:false}],
      id: [{value: id ? id : undefined, disabled:false}],
      theme: [{value: theme ? theme : undefined, disabled:false}],
      comment: [{value: comment ? comment : undefined, disabled:false}],
      name: [{value: name ? name : undefined, disabled:false}],
      templateName: [{value: templateName ? templateName : undefined, disabled:false}],
      contentType: [{value: contentType ? contentType : this.contentTypeId, disabled:false}],
      customer: [{value: customer ? customer : undefined, disabled:false}],
      tridyId: [{value: tridyId ? tridyId : undefined, disabled:false}],
      widgets:[{value: widgets ? widgets : undefined, disabled:false}],
      translations: [{value: translations ? translations : undefined, disabled:false}],
      languages:[{value: languages ? languages : undefined, disabled:false}],
      enableShoppingCart: [{value: enableShoppingCart ? enableShoppingCart : false, disabled:false}],
      enableCustomerLogin: [{value: enableCustomerLogin ? enableCustomerLogin : false, disabled:false}]
    })

    this.dppThemeService.setWidgetSpacingCornerRadius(theme)
    this.templateForm.valueChanges.subscribe(values=> {
      this.changesToSave=true
    })

    this.templateForm.get('languages')?.valueChanges.subscribe(values=> {
      this.dppTranslations.updatepassLanguagesList(languages)
    })

    if(this.templateForm.value.languages && this.templateForm.value.languages.length!=0){
      this.passDefaultLanguage = this.templateForm.value.languages[0]
      this.dppTranslations.setDefaultLanguagePass(this.passDefaultLanguage)
    }
  }

  changeTheme(value){///change this after change toggle dark(light)
    this.darkMode=value
    if(this.darkMode)
      this.dppThemeService.setColorsToDark(this.themeData)
    else
      this.dppThemeService.setColorsToLight(this.themeData)
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.allWidgets, event.previousIndex, event.currentIndex);
    this.updateFormValue()
  }

  deleteWidget(el: any, index: number) {
    if (el.type === "productRegistration") this.disableProductRegistration = false;

    const widgetId = this.allWidgets[index]?.id;
    const registeredViewKey = `registeredView_${this.idToShow}_${widgetId}`;
    this.localStorageService.remove(registeredViewKey);

    if (this.selectedWidgetId === widgetId) this.clearSelection();

    this.allWidgets.splice(index, 1);
    this.idsList.splice(index, 1);
    this.updateFormValue();
  }

  async duplicateWidget(el: any, i: number) {

    let id = makeid(6);
    this.idValue++;
    id = id + (this.idValue + 1) + "";

    const newWidget = deepCopy(el);
    const insertIndex = i + 1;

    this.idsList.splice(insertIndex, 0, id);
    newWidget.id = this.idsList[insertIndex];

    const oldId = el.id;
    const newId = newWidget.id;
    const nestedIdMap: Record<string, string> = {};

    if (el.type === "buttons" && Array.isArray(newWidget.buttons)) {
      newWidget.buttons.forEach((btn: any, idx: number) => {
        const oldBtnId = el.buttons?.[idx]?.id;
        const newBtnId = makeid(10);
        btn.id = newBtnId;
        if (oldBtnId) nestedIdMap[oldBtnId] = newBtnId;
      });
    }

    if (el.type === "images" && Array.isArray(newWidget.images)) {
      newWidget.images.forEach((img: any, idx: number) => {
        const oldImgId = el.images?.[idx]?.id;
        const newImgId = makeid(6);
        img.id = newImgId;
        if (oldImgId) nestedIdMap[oldImgId] = newImgId;
      });
    }
    
    if (el.type === "annotatedMap" && Array.isArray(newWidget.annotations)) {
      newWidget.annotations.forEach((a: any) => {
        a.id = makeid(6);
      });
    }

    if (el.type === "composed" && Array.isArray(newWidget?.content)) {
      newWidget.content.forEach((node: any) => {
        changeComposeNodeId(node);
      });
    }

    if (el.type === "form" && Array.isArray(newWidget.sections)) {
      el.sections?.forEach((oldSection: any, sIdx: number) => {
        const newSection = newWidget.sections[sIdx];
        if (!oldSection || !newSection) return;

        const newSectionId = makeid(6);
        nestedIdMap[oldSection.id] = newSectionId;
        newSection.id = newSectionId;

        oldSection.fields?.forEach((oldField: any, fIdx: number) => {
          const newField = newSection.fields?.[fIdx];
          if (!oldField || !newField) return;

          const newFieldId = makeid(6);
          nestedIdMap[oldField.id] = newFieldId;
          newField.id = newFieldId;

          oldField.options?.forEach((oldOpt: any, oIdx: number) => {
            const newOpt = newField.options?.[oIdx];
            if (!oldOpt || !newOpt) return;

            const newOptId = makeid(6);
            nestedIdMap[oldOpt.id] = newOptId;
            newOpt.id = newOptId;
          });
        });
      });
    }

    // TRANSLATIONS
    const currentTranslations = this.getActiveTranslations();
    const updatedTranslations = renameTranslationKeys( currentTranslations, oldId, newId, nestedIdMap );
    this.setActiveTranslations(updatedTranslations);

    this.allWidgets.splice(insertIndex, 0, newWidget);
    this.updateIds();
    this.selectWidgetById(newWidget.id);
  }

  clearSelection(): void { this.selectedWidgetId = null; }

  @HostListener('document:keydown', ['$event'])
  handleKeyboardShortcuts(event: KeyboardEvent): void {
    const isModifierPressed = event.metaKey || event.ctrlKey;
    if (!isModifierPressed) return;

    const selection = window.getSelection();
    const hasTextSelection = selection && selection.toString().length > 0;

    if (event.key === 'c' || event.key === 'C') {
      if (hasTextSelection) {
        this.widgetClipboardService.clear();
        return;
      }
      if (this.isDialogEditOpen) return;

      const idx = this.getSelectedIndex();
      if (idx < 0) return;

      event.preventDefault();
      event.stopPropagation();

      const widget = this.allWidgets[idx];
      if (widget && widget.type !== 'productRegistration') {
        this.copyWidgetToClipboard(widget);
        navigator.clipboard.writeText('').catch(() => {});
      }
    }

    else if (event.key === 'v' || event.key === 'V') {
      if (this.isDialogEditOpen) return;

      if (this.widgetClipboardService.hasWidget()) {
        event.preventDefault();
        event.stopPropagation();
        this.pasteWidgetFromClipboard();
      }
    }
  }

  async copyWidgetToClipboard(el: any): Promise<void> {
    const slice = pickWidgetTranslations(el.id, this.getActiveTranslations());
    this.widgetClipboardService.setWidget(el, this.idToShow, slice);
    this.commentService.addSnackBar.emit( this.translate.instant('SnackBarConstants.COPIED_TO_CLIPBOARD') );
  }

  async pasteWidgetFromClipboard(): Promise<void> {
    const widget = this.widgetClipboardService.getWidget();
    const sourcePassId = this.widgetClipboardService.getSourcePassId();
    const slice = this.widgetClipboardService.getTranslationsSlice();
    if (!widget) return;

    if (sourcePassId && sourcePassId !== this.idToShow) {
      try {
        this.commentService.progressSpin.emit(true);
        await this.copyPassImagesInWidget(widget, sourcePassId, this.idToShow);
      } finally {
        this.commentService.progressSpin.emit(false);
      }
    }

    const oldId = widget.id;
    const insertIndex = this.getInsertIndex();

    await this.duplicateWidget(widget, insertIndex - 1);

    const newWidget = this.allWidgets[insertIndex];
    if (newWidget?.id) {
      const nestedIdMap = buildNestedIdMap(widget, newWidget);
      this.applyTranslationSlice(oldId, newWidget.id, slice, nestedIdMap);
    }

    if (widget.type === 'productRegistration')
      this.disableProductRegistration = true;
    
  }

  get hasWidgetInClipboard(): boolean { return this.widgetClipboardService.hasWidget(); }

  private async copyPassImagesInWidget( widget: any, sourcePassId: string, targetPassId: string): Promise<void> {
    const widgetId = makeid(6) + (this.idValue + 1);
    let imageCounter = 0;

    await processObjectRecursively(widget, async (value: any, path: string[]) => {
      if (typeof value === 'string' && value.startsWith('pass://')) {
        try {
          const timestamp = this.uploadService.getRandomName();
          const newUrl = await this.uploadService.copySingleImage( value, sourcePassId, targetPassId, `${timestamp}${widgetId}${imageCounter++}.jpg` );
          setNestedValue(widget, path, newUrl);
        } catch (error) {
          console.error(`Failed to copy image at path ${path.join('.')}:`, error);
        }
      }
    });
  }

  updateFormValue(){
    let widgets:any=[]
    this.widgetsForm.reset()
    this.allWidgets.forEach((w:any,ind:any) =>{ widgets.push(w) })
    this.widgetsForm.patchValue(widgets)
    this.templateForm.patchValue({ widgets: this.allWidgets })
  }

  checkTypeNumber(el, indexWidget){
    let typeNumber = 1
    this.allWidgets.forEach((widget, index) => {
      if(index<indexWidget){
        if(widget.type == el.type){
          typeNumber ++
        }
      }
    })
    return typeNumber.toString()
  }

  updateIds(){
    this.allWidgets.forEach( (widget, index) => { widget.id = this.idsList[index] })
    this.updateFormValue()
  }

  editTemplate(){
    this.templateData = new Template ()
    this.templateData.setFromAny(this.passTemplateLanguagesO['default'])

    if (this.passLanguages.length != 0)
      this.languageSelected = this.passLanguages[0]
    else
      this.languageSelected = this.contextFirstLanguage

    this.editTemp = true
    const oldTemplate = this.templateData
    this.oldTemplateData = deepCopy(oldTemplate)
    this.name = "Template-" + this.templateData.id

    const mainTab: TabState = {
      id: 'main',
      isMain: true,
      name: this.templateData.name,
      widgets: deepCopy(this.templateData.widgets || []),
      translations: deepCopy(this.templateData.translations || {}),
      languages: deepCopy(this.templateData.languages || []),
      enableShoppingCart: !!this.templateData.enableShoppingCart,
      enableCustomerLogin: !!this.templateData.enableCustomerLogin
    };

    this.dppLanguagesChanges$.next(this.templateData.languages || [])
    this.tabs = [mainTab];
    this.activeTabId = 'main';
    this.renameTabs();

    // Build form just once from main tab
    this.initializeFormsFromTab(mainTab);
  }

  private initializeFormsFromTab(tab: TabState) {
    this.idsList = [];
    this.widgetsForm = this.fb.group({});
    this.allWidgets = deepCopy(tab.widgets || []);
    this.allWidgets.forEach(w => this.idsList.push(w.id));

    this.templateForm = this.fb.group({
      contextId: [this.templateData.contextId],
      id: [this.templateData.id],
      theme: [this.templateData.theme],
      comment: [this.templateData.comment],
      name: [tab.name],
      templateName: [this.templateData.templateName],
      contentType: [this.templateData.contentType || this.contentTypeId],
      customer: [this.templateData.customer],
      tridyId: [this.templateData.tridyId],
      widgets: [tab.widgets],
      translations: [tab.translations],
      languages: [tab.languages],
      enableShoppingCart: [tab.enableShoppingCart || false],
      enableCustomerLogin: [tab.enableCustomerLogin || false],
    });

    this.dppThemeService.setWidgetSpacingCornerRadius(this.templateData.theme);

    this.templateForm.get('languages')?.valueChanges.subscribe((v) => {
      this.dppLanguagesChanges$.next(v)
    })

    this.templateForm.valueChanges.subscribe(() => {
      this.changesToSave = true;

      const t = this.activeTab;
      const v = this.templateForm.value;
      //console.log(v)
      t.widgets = deepCopy(v.widgets || []);
      t.translations = deepCopy(v.translations || {});
      t.languages = deepCopy(v.languages || []);
      this.dppLanguagesChanges$.next(t.languages)
      if (t.isMain)
        t.name = v.name || t.name;

      t.enableShoppingCart = !!v.enableShoppingCart;
      t.enableCustomerLogin = !!v.enableCustomerLogin;
    });

    // language-default stuff remains same...
  }

  backTo(){ this.route.navigate(['/home', this.settingsService.contextId$, 'contentTypes']) }

  openDialogEditTheme():void{
    this.isDialogEditOpen = true;
    let dialogRef= this.dialog.open(PassTemplatesThemeEditComponent, {
      data:{
        formData: this.templateForm.value,
        oldData:this.oldTemplateData,
        contextId: this.settingsService.contextId$
      },
      panelClass: 'custom-dialog-container',
      position: { right: '0'},
      enterAnimationDuration: '200ms',
      exitAnimationDuration: '200ms'
    });

    dialogRef.afterClosed().subscribe(value => {
      this.isDialogEditOpen = false;
      if(value[0]){
        const result = value[1]
        this.templateForm.patchValue({theme: result.theme,languages: result.languages , comment: result.comment, name: result.name, templateName: result.templateName, contentType: result.contentType, customer: result.customer, tridyId: result.tridyId,enableShoppingCart: result.enableShoppingCart,enableCustomerLogin: result.enableCustomerLogin })
        if(result.languages){
          this.passLanguages=result.languages
          this.languagesPassList=this.passLanguages
          this.passFirstLanguage = result.languages[0]
          if(this.passFirstLanguage)
            this.languageSelected = this.passFirstLanguage
        }
        this.themeData = this.templateForm.value.theme

        this.dppThemeService.updateColors(this.themeData);
        this.dppThemeService.updateColorsDark(this.themeData)

        if(this.darkMode)
          this.dppThemeService.setColorsToDark(this.themeData)
        else
          this.dppThemeService.setColorsToLight(this.themeData)

        this.dppThemeService.updateFonts(this.themeData)
        this.dppThemeService.setWidgetSpacingCornerRadius(result.theme)
      }
    });
  }

  openDialogEditSettings():void{
    this.isDialogEditOpen = true;
    if(this.checkLicenseFree){
      let dialogRef= this.dialog.open(FreePublisherInfoDialogComponent, {
        panelClass: 'freepublisher-dialog-container',
        data:{
          closeBtnLabel:this.translate.instant('free_publisher.close_publish')
        }
      });
      dialogRef.afterClosed().subscribe(result => {
        this.isDialogEditOpen = false;
        this.manageDataBeforeSaving()
      })
    }else{
      const dtabs = deepCopy(this.tabs)

      let dialogRef= this.dialog.open(PassTemplatesSettingsEditComponent, {
        data:[this.templateForm.value,this.settingsService.contextId$, dtabs, deepCopy(this.activeTabId) ],
        panelClass: 'custom-dialog-container',
        position: { right: '0'},
        enterAnimationDuration: '200ms',
        exitAnimationDuration: '200ms'
      });

      dialogRef.afterClosed().subscribe(value => {
        //console.log(value)
        this.isDialogEditOpen = false;
        if(value[0]){
          const result = value[1]
          const resultTabs = value[2]
          const languagesBeforeChange = deepCopy(this.templateForm.value.languages) ?? []
          const widgetsBeforeChange = deepCopy(this.templateForm.value.widgets)
          const firstLanguageBeforeChange = languagesBeforeChange[0] ?? this.contextFirstLanguage
          //update childs
          const tabs = dtabs.filter(t => t.id != this.activeTabId) // remove from selectedTab list of updated tabs
          const selectedTab = dtabs.find(t => t.id === this.activeTabId) // get selectedTab
          const selectedTabIndex = dtabs.findIndex(t => t.id === this.activeTabId) // get selectedTab index
          resultTabs.splice(selectedTabIndex, 0, selectedTab) // inject selectedTab in respectove index on updated tabs
          //console.log(resultTabs)
          this.tabs = resultTabs
          //update form
          this.templateForm.patchValue({
            comment: result.comment,
            name: result.name,
            templateName: result.templateName,
            enableShoppingCart: result.enableShoppingCart,
            enableCustomerLogin: result.enableCustomerLogin,
            languages: result.languages
          })

          this.passLanguages = this.templateForm.value.languages
          this.languagesPassList = this.templateForm.value.languages
          if(this.templateForm.value.languages && this.templateForm.value.languages.length!=0){
            this.passDefaultLanguage = this.templateForm.value.languages[0]
            this.passFirstLanguage =  this.templateForm.value.languages[0]
            this.languageSelected = this.passFirstLanguage
            this.dppTranslations.setDefaultLanguagePass(this.passDefaultLanguage)
          }else{
            this.passDefaultLanguage = this.contextFirstLanguage
          }
          const firstLanguageAfterChange = this.passDefaultLanguage
          if(firstLanguageBeforeChange != firstLanguageAfterChange){
            this.templateForm.patchValue( {translations:result.translations})
            this.allWidgets = result.widgets
            this.updateIds()
          }
          this.checkTranslationAvailability()
        }
      });
    }
  }

  clickList(elem: any, index: number, e: MouseEvent) {
    if (this.isDialogEditOpen) return;

    const clickedId = elem?.id;

    if (this.selectedWidgetId === clickedId) {
      this.openDialogEdit(elem, index);
      return;
    }

    this.selectWidgetById(clickedId);
  }

  private openDialogEdit(elem:any, index){
    var dialogEditName:any = WidgetEditDialogComponent

    // pass anchor and child options to widgets
    const anchorOptions = this.widgetAnchorOptions;
    const childPages = this.childPageLinkOptions;
    const currentContentTypeId = this.contentTypeId || this.templateForm?.value?.contentType || this.contentType?.id;
    const currentContentTypeSchema = this.contentType?.schema;

    var data:any
    data = {
      translateMode:false,
      widgetId: elem.id,
      values: elem,
      passId: this.idToShow,
      defaultLanguage: this.passDefaultLanguage,
      languages:this.languagesPassList,
      translations: this.templateForm.value.translations,
      widget:index,
      type:elem.type,
      contentTypeId: currentContentTypeId,
      contentTypeSchema: currentContentTypeSchema,
      anchorOptions,
      childPages,
      activeTabId:this.activeTabId,
    };

    switch (elem.type){
        case 'billboardImage': {
          dialogEditName = WidgetEditDialogComponent
          data = {
            translateMode:false,
            widgetId: elem.id,
            values: elem,
            passId: this.idToShow,
            defaultLanguage: this.passDefaultLanguage,
            languages:this.languagesPassList,
            translations: this.templateForm.value.translations,
            widget:index,
            type:elem.type,
            contentTypeId: currentContentTypeId,
            contentTypeSchema: currentContentTypeSchema,
            anchorOptions,
            childPages,
            activeTabId:this.activeTabId,
          }
          break;
        }
        case 'billboardVideo': {
          break;
        }
        case 'buttons': {
          break;
        }
        case 'text': {
          break;
        }
        case 'image': {
          data = {
            translateMode:false,
            widgetId: elem.id,
            values: elem,
            passId: this.idToShow,
            defaultLanguage: this.passDefaultLanguage,
            languages:this.languagesPassList,
            translations: this.templateForm.value.translations,
            widget:index,
            type:elem.type,
            contentTypeId: currentContentTypeId,
            contentTypeSchema: currentContentTypeSchema,
            anchorOptions,
            childPages,
            activeTabId:this.activeTabId,
          }
          break;
        }
        case 'annotatedMap': {
          break;
        }
        case 'callToAction': {
          dialogEditName = WidgetEditDialogComponent
          data = {
            translateMode:false,
            widgetId: elem.id,
            values: elem,
            passId: this.idToShow,
            defaultLanguage: this.passDefaultLanguage,
            languages:this.languagesPassList,
            translations: this.templateForm.value.translations,
            widget:index,
            type:elem.type,
            contentTypeId: currentContentTypeId,
            contentTypeSchema: currentContentTypeSchema,
          }
          break;
        }
        case 'products': {
          dialogEditName=ProductsEditComponent
          data = {
            values:elem,
            widget:index,
            passId: this.idToShow,
            defaultLanguage: this.passDefaultLanguage
          }
          break;
        }
        case 'chat': {
          dialogEditName=ChatEditComponent
          data = {
            values: elem,
            widget:index,
            passId: this.idToShow,
            defaultLanguage: this.passDefaultLanguage,
          }
          break;
        }
        case 'productRegistration': {
          break;
        }
        case 'shopifyProducts': {
          dialogEditName="ShopifyProductsEditComponent"
          break;
        }
        case 'video': {
          break;
        }
        case 'splashVideo': {
          break;
        }
        case 'spacer': {
          dialogEditName=SpacerEditComponent
          data = {
            values: elem,
            widget:index,
            passId: this.idToShow,
            defaultLanguage: this.passDefaultLanguage
          }
          break;
        }
        case 'imageBlocks': {
          break;
        }
        case 'imagesHorizontal': {
          break;
        }
        case 'images': {
          break;
        }
        case '3dmodel': {
          dialogEditName=Model3dEditComponent
          data = {
            values: elem,
            widget:index,
            passId: this.idToShow,
            defaultLanguage: this.passDefaultLanguage
          }
          break;
        }
        case 'list': {
          dialogEditName=ListEditComponent
          data = {
            values: elem,
            widget:index,
            passId: this.idToShow,
            defaultLanguage: this.passDefaultLanguage
          }
          break;
        }
        case 'form': {
          break;
        }
        case 'countdown': {
          break;
        }
        case 'composed': {
          break;
        }
        case 'oneClickPay':{
          dialogEditName = OneclickpayEditComponent
          data = {
            values: elem,
            widget:index,
            passId: this.idToShow,
          }
          break;
        }
        //--------add support for missing widgets
        case 'instagram':{
          const message = this.translate.instant('users.not_available')
          this.commentService.addSnackBar.emit(message)
          return;
          break;
        }
        case 'html':{
          const message = this.translate.instant('users.not_available')
          this.commentService.addSnackBar.emit(message)
          return;
          break;
        }
        case 'smartAR':{
          const message = this.translate.instant('users.not_available')
          this.commentService.addSnackBar.emit(message)
          return;
          break;
        }
        case 'group':{
          const message = this.translate.instant('users.not_available')
          this.commentService.addSnackBar.emit(message)
          return;
          break;
        }
        case 'notification':{
          const message = this.translate.instant('users.not_available')
          this.commentService.addSnackBar.emit(message)
          return;
          break;
        }
        case 'shopify':{
          const message = this.translate.instant('users.not_available')
          this.commentService.addSnackBar.emit(message)
          return;
          break;
        }
    }

    this.isDialogEditOpen = true;
    let dialogRef = this.dialog.open(dialogEditName, {
      maxWidth: '700px',
      minWidth: '700px',
      data:data,
      panelClass: 'custom-widget-dialog-container',
      position: { right: '0'},
      enterAnimationDuration: '200ms',
      exitAnimationDuration: '200ms'
    });

    dialogRef.afterClosed().subscribe(result => {
      this.isDialogEditOpen = false;
      if(result[1]){
        let translationsnew
        if(result[3]){
          translationsnew = result[3]
        }
        const event = {newdata: result[0], widget: index, widgetType: elem.type, translations: translationsnew}
        this.returnChangesActive(event)
      }
    })
  }

  QRoptions(){
    const content = {
      contentType: this.idToShow,
      contextId: this.settingsService.contextId$
    }
    let dialogRef= this.dialog.open(QrCodeDialogComponent, {
      data: {
        contentType:content,
        id: this.contentTypeId,
        nfcPrefix: this.usesAppClip() ? this.contentType?.nfcURLPrefix : undefined,
        name: this.templateForm.value.name ?? this.templateForm.value.templateName ?? this.contentType?.displayName,
        hasDraft: this.hasDraft,
        draftId: this.draftId
      }
    });
    dialogRef.afterClosed().subscribe(result => { });
  }

  private usesAppClip(): boolean {
    const context = this.settingsService.contextAccount$;
    return !String(context?.customDPPHost || '').trim();
  }

  addWidget(name: string) {
    let id = makeid(6);
    this.idValue = this.idValue + 1;
    id = id + (this.idValue + 1) + "";

    const newWidget = deepCopy(defaultWidgets[name]);
    removeUndefined(newWidget);
    newWidget['id'] = id;

    if (name === "buttons") {
      const colorDefaults = getButtonColorDefaults();
      newWidget.buttons[0].id = makeid(10);
      newWidget.buttonsStyle = {
        borderWidth: newWidget.buttonsStyle?.borderWidth ?? 0,
        darkColors: {
          background: colorDefaults?.dark?.background ?? "#FF5E38",
          border: colorDefaults?.dark?.border ?? "#FF5E38",
          primary: colorDefaults?.dark?.primary ?? "#ffffff"
        },
        lightColors: {
          background: colorDefaults?.light?.background ?? "#FF5E38",
          border: colorDefaults?.light?.border ?? "#FF5E38",
          primary: colorDefaults?.light?.primary ?? "#000000"
        }
      };
    }

    const selectedIndex = this.getSelectedIndex();
    const insertIndex = selectedIndex >= 0 ? selectedIndex + 1 : this.allWidgets.length;

    this.allWidgets.splice(insertIndex, 0, newWidget);
    this.idsList.splice(insertIndex, 0, id);

    if (name === "productRegistration")
      this.disableProductRegistration = true;

    this.updateIds();
    this.selectWidgetById(newWidget.id);
  }

  showTranslatedPass(lang){
    const template = new Template()
    const copydefault = deepCopy(this.settingsPass[0])
    template.setFromAny(copydefault)

    const {id, contextId, theme, comment, name, contentType, customer, tridyId, widgets, translations,languages} = template
    let teform = this.fb.group({
      contextId: [contextId ? contextId : undefined],
      id: [id ? id : undefined],
      theme: [theme ? theme : undefined],
      comment: [comment ? comment : undefined],
      name: [name ? name : undefined],
      contentType: [contentType ? contentType : undefined],
      customer: [customer ? customer : undefined],
      tridyId: [tridyId ? tridyId : undefined],
      widgets: [widgets ? widgets : undefined],
      translations: [translations ? translations : undefined],
      languages: [languages ? languages : undefined]
    })
    if(this.editTemp == false){
      if(this.templateData.translations && this.templateData.translations[lang] ){
        const entries = Object.entries(this.templateData.translations[lang])

        entries.forEach( translation => {
          const idField = translation[0].split(".")
          const id = idField[0]
          const field = idField[1]
          const value = translation[1]

          if(teform.value.widgets){
            const widgets = teform.value.widgets
            widgets.forEach( (widget:any, index:any) => {
              if(widget['id'] == id){ widget[field] = value }
            })
            teform.patchValue({widgets: widgets})
          }

        })

        if(!this.passTemplateLanguagesO[lang])
          this.passTemplateLanguages.push(teform.value)
        this.passTemplateLanguagesO[lang]=teform.value
      }else{
        this.passTemplateLanguages.push(teform.value)
        this.passTemplateLanguagesO[lang]=teform.value
      }
    }
  }

  changePassLanguage(lang){
    this.templateData = new Template()
    this.templateData.setFromAny(this.passTemplateLanguagesO['default'])
    this.showTranslatedPass(lang)
    if(!this.passTemplateLanguagesO[lang]){
      this.templateData = new Template()
      this.templateData.setFromAny(this.passTemplateLanguagesO['default'])
    }else{
      this.templateData = new Template()
      this.templateData.setFromAny(this.passTemplateLanguagesO[lang])
    }
  }

  async saveEditTemplateValues(saveMode: 'draft' | 'publish' = 'draft'){
    this.editTemp=false

    const mainTab = this.tabs.find(t => t.isMain);
    if (!mainTab) return; // fallback: no main tab found

    if (this.activeTabId === mainTab.id) {
      const v = this.templateForm.value;
      mainTab.widgets = deepCopy(v.widgets || []);
      mainTab.translations = deepCopy(v.translations || {});
      mainTab.languages = deepCopy(v.languages || []);
      mainTab.enableShoppingCart = !!v.enableShoppingCart;
      mainTab.enableCustomerLogin = !!v.enableCustomerLogin;
      mainTab.name = v.name || mainTab.name;
    }
    const dppLanguages = this.dppLanguagesChanges$.getValue()

    const value = this.templateForm.value
    const {id, contextId, theme, comment, templateName, contentType, customer, tridyId} = value
    const newPassDefValues = {
      contextId: contextId,
      id: id,
      theme: theme,
      comment: comment,
      name: mainTab.name,
      templateName: templateName,
      contentType: contentType,
      customer: customer,
      tridyId: tridyId,
      widgets: mainTab.widgets,
      translations: mainTab.translations,
      languages: dppLanguages ?? mainTab.languages,
      enableShoppingCart:mainTab.enableShoppingCart,
      enableCustomerLogin:mainTab.enableCustomerLogin
    }

    //remove lat, lng values of maps before saving on firestore
    // const newPasDefinitonValuesCleanedMap = deepCopy(newPasDefinitonValues)
    // if(newPasDefinitonValuesCleanedMap.widgets){
    //   newPasDefinitonValuesCleanedMap.widgets.forEach(async widget => {
    //     if(widget.type == 'annotatedMap'){
    //       if(widget.annotations){
    //         widget.annotations.forEach(annotation => {
    //           if(annotation.lat && annotation.lng){
    //             if(annotation.coordinate){
    //               annotation['coordinate'] = [annotation['lat'], annotation['lng']]
    //             }
    //             delete annotation['lat']
    //             delete annotation['lng']
    //           }

    //           if(annotation.dynamic){ // NAR-5041
    //             if(annotation.source === "workTasks")
    //               annotation.source = "payload"
    //           }
    //         });
    //       }
    //     }

    //     if(widget.type == 'countdown'){
    //       if(widget.targetDate){
    //         const date = isDateTimeGetTimeSeconds(widget.targetDate)
    //         const newdate = new Date(date)
    //         const minDate = new Date('1970-01-01T00:00').getTime()

    //         if (newdate.getTime() < 0 || isNaN(newdate.getTime())) {
    //           if(minDate > newdate.getTime())
    //             widget.targetDate = new Date(minDate)
    //         }else{
    //           widget.targetDate = newdate
    //         }
    //       }
    //     }

    //     //add if any from images is missing id
    //     if(widget.type == 'images'){
    //       const missingId = widget?.images.find( image => !image.id)
    //       if(missingId){
    //         widget?.images.forEach(image => {
    //           if(!image.id){
    //             image.id = makeid(5)
    //           }
    //         });
    //       }

    //     }
    //     //add if any from composed is missing id
    //     if(widget.type == 'composed'){
    //       await widget?.content.forEach(node => {
    //         checkComposeNodeId(node)
    //       });
    //     }
    //     //--- uncomment this to autom. change videos to new structure withtype, layout
    //     // if(widget.type === 'video'){
    //     //   if(!widget.layout)
    //     //     widget.layout = 'standard'
    //     // }

    //     // if(widget.type === 'splashVideo'){
    //     //     widget.layout = 'splash'
    //     //     widget.type = 'video'
    //     // }
    //     // if(widget.type === 'billboardVideo'){
    //     //   widget.layout = 'billboard'
    //     //   widget.type = 'video'
    //     // }
    //   });
    // }

    // //delete '' translations
    // const newPasDefinitonValuesCleanedTranslations = deepCopy(newPasDefinitonValuesCleanedMap)
    // if(newPasDefinitonValuesCleanedTranslations.translations ){
    //   if(this.oldTemplateData.translations){
    //     const languages = Object.keys(newPasDefinitonValuesCleanedTranslations.translations)
    //     const translations = deepCopy(newPasDefinitonValuesCleanedTranslations.translations)
    //     const oldTranslations = deepCopy(this.oldTemplateData.translations)

    //     languages.forEach ( (language, index) => {
    //       if(translations[language]){
    //         const keys = Object.keys(translations[language])
    //         keys.forEach(key => {
    //           const idKeyField = key.split('.')
    //           const id = idKeyField[0]

    //           if(newPasDefinitonValuesCleanedTranslations.widgets && newPasDefinitonValuesCleanedTranslations.widgets.length!=0){
    //             if(!newPasDefinitonValuesCleanedTranslations.widgets.find( widget => id.includes(widget.id))){
    //               // if(!newPasDefinitonValuesCleanedTranslations.widgets.find( widget => widget.id == id)){
    //               newPasDefinitonValuesCleanedMap.translations[language][key] = deleteField()
    //               delete newPasDefinitonValues.translations[language][key]

    //             }else{
    //               let value = translations[language][key]

    //               // if( value == ''){
    //               //   if(!oldTranslations[language] || !oldTranslations[language][key] || oldTranslations[language][key]== ''){
    //               //     value = undefined
    //               //   }
    //               // }
    //               if(!value && oldTranslations && oldTranslations[language] && oldTranslations[language][key]){
    //                 newPasDefinitonValuesCleanedMap.translations[language][key] = deleteField()
    //                 delete newPasDefinitonValues.translations[language][key]
    //               }
    //             }
    //           }else{
    //             newPasDefinitonValuesCleanedMap.translations = deleteField()
    //             delete newPasDefinitonValues.translations
    //           }

    //         })

    //         if(keys.length == 0){
    //           newPasDefinitonValuesCleanedMap.translations[language] = deleteField()
    //           delete newPasDefinitonValues.translations[language]
    //         }
    //       }
    //     })

    //     if( Object.keys(translations).length != 0){
    //       removeUndefined(translations)
    //       newPasDefinitonValues.translations == translations
    //     }else{
    //       // newPasDefinitonValues.translations == undefined
    //       // newPasDefinitonValuesCleanedMap.translations = deleteField()
    //     }
    //   }
    //   //delete translations of languages not included
    //   if(newPasDefinitonValuesCleanedTranslations.translations && newPasDefinitonValuesCleanedTranslations.languages){ // this.oldTemplateData.languages
    //     const languages = newPasDefinitonValuesCleanedTranslations.languages
    //     const firstLanguage = newPasDefinitonValuesCleanedTranslations.languages[0]
    //     removeUndefined(newPasDefinitonValuesCleanedTranslations.translations)
    //     removeUndefined(newPasDefinitonValuesCleanedMap.translations)
    //     removeUndefined(newPasDefinitonValues.translations)

    //     if(JSON.stringify(languages) != JSON.stringify(this.oldTemplateData.languages)){

    //       const translations = Object.keys(newPasDefinitonValuesCleanedTranslations.translations)
    //       translations.forEach( lang => {
    //         if(!languages.includes(lang) || lang == firstLanguage ){
    //           newPasDefinitonValuesCleanedMap.translations[lang] = {}
    //           newPasDefinitonValuesCleanedMap.translations[lang] = deleteField()
    //           delete newPasDefinitonValues.translations[lang]
    //         }
    //       })
    //     }

    //   }
    // }

    const {newPasDefinitonValuesCleanedMap, newPasDefinitonValues} = this.passDefinitionService.cleanTemplateBeforeSave(this.oldTemplateData, newPassDefValues)

    this.templateData.setFromAny(newPasDefinitonValues)
    const copia = deepCopy(this.templateData)
    this.changesToSave=false
    const oldTemplate=this.templateData
    this.oldTemplateData=deepCopy(oldTemplate)

    try{
      this.commentService.progressSpin.emit(true)
      //------do not delete this------------
      // if(this.unexistingPass){
      // await this.passDefinitionService.setPassDefinition(this.templateData)
      await this.passDefinitionService.setPassDefinitionDraft(newPasDefinitonValuesCleanedMap)

      const value = this.templateForm.value
      const {contextId, contentType} = value

      // save children
      const childTabs = this.tabs.filter((t) => !t.isMain);

      const childrenPayload = childTabs.map((t) => ({
        contextId: contextId,
        contentType: contentType,
        id: t.id,
        name: t.name,
        widgets: t.widgets || [],
        translations: deepCleanTranslations(t.translations || {}),
        languages: dppLanguages ?? (t.languages || []),
        enableShoppingCart: t.enableShoppingCart,
        enableCustomerLogin: t.enableCustomerLogin,
        creationDate: t.creationDate ?? Date.now(),
      }));

      const cleanedChilds = deepCopy(childrenPayload).map( child => {
        const cleaned = this.passDefinitionService.cleanTemplateBeforeSave(this.oldChildTemplateData[child.id] || {}, child)
        return cleaned.newPasDefinitonValuesCleanedMap
      })
      await this.passDefinitionService.setPassDraftChildren( this.templateData.id, cleanedChilds );

      if (saveMode === 'publish') {
        await this.passDefinitionService.publishPassDefinitionDraft(this.templateData.id);
        this.hasDraft = false;
        this.draftLoaded = false;
        this.draftId = undefined;
      } else {
        this.hasDraft = true;
        this.draftLoaded = true;
        this.draftId = this.templateData?.draftId || this.templateData?.id || this.idToShow;
      }

      // }else{
      // await this.passDefinitionService.updatePassDefinition(this.templateData)
      // await this.passDefinitionService.updatePassDefinition(newPasDefinitonValuesCleanedMap)
      // }
      this.commentService.progressSpin.emit(false)
      this.unexistingPass=false
      this.allWidgets= []
      this.dppThemeService.updateFonts(this.themeData)
      this.passTemplateLanguages=[]
      this.settingsPass=[]
      this.passTemplateLanguagesO['default']= newPasDefinitonValues
      this.settingsPass.push(copia)
      this.editTemplate();
      await this.loadChildTabs(this.hasDraft);
      const message = saveMode === 'publish'
        ? this.translate.instant("SnackBarConstants.UPDATE_OK")
        : (this.translate.instant("SnackBarConstants.DRAFT_SAVED") || this.translate.instant("SnackBarConstants.UPDATE_OK"))
      this.commentService.addSnackBar.emit(message)
    } catch(error){
      console.log(error)
      this.commentService.progressSpin.emit(false)
      const message = this.translate.instant("SnackBarConstants.UPDATE_FAILED")
      this.commentService.addSnackBar.emit(message)
    }
  }

  saveDraft(){
    this.saveEditTemplateValues('draft')
  }

  prepareToSave(){
    if(this.checkLicenseFree){
      let dialogRef= this.dialog.open(FreePublisherInfoDialogComponent, {
        panelClass: 'freepublisher-dialog-container',
        data:{
          closeBtnLabel:this.translate.instant('free_publisher.close_publish')
        }
      });
      dialogRef.afterClosed().subscribe(result => {
        this.manageDataBeforeSaving()
      })
    }else{
      this.manageDataBeforeSaving()
    }
  }

  async manageDataBeforeSaving(){
    this.uploadService.setImagesUploaded()
    this.uploadService.setFontsUploaded()

    try {
      await this.contentTypeService.updateContentTypeTimestamp(this.contentTypeId);
    } catch (error) {
      console.error('Failed to update Timestamp:', error);
    }

    try{
      this.commentService.progressSpin.emit(true)

      if(this.tridyCount>1){
        this.commentService.progressSpin.emit(false)
        let dialogRef= this.dialog.open(UpdateConfirmationDialogComponent, {
          data:{
            type: 'passTemplate',
            title: 'publishDesign',
            message: 'pass.tridy_update',
            question: 'pass.tridy_update_question',
            tridyCount : this.tridyCount
          }
        });

        dialogRef.afterClosed().subscribe(result => {
          if(result[0]){
            this.commentService.progressSpin.emit(true)
            setTimeout(() =>{ this.saveEditTemplateValues('publish') }, 800);
          }
        });
      }else{
        setTimeout(() =>{ this.saveEditTemplateValues('publish') }, 800);
      }

    }catch(error){
      console.log(error)
      this.commentService.progressSpin.emit(false)
    }
  }

  returnChangesActive(event: any){
    if(event.newdata){
      const data = event.newdata
      removeUndefinedValuesFromObject(data)
      this.allWidgets.forEach( (w,index) =>{
        if(w.id == data.id /*&& w.type == data.type*/)
          this.allWidgets[index]=data
      })
    }

    if(event.translations)
      this.templateForm.patchValue({translations : event.translations})
      this.updateFormValue()
  }

  returnChangesActiveTranslations(event:any){
    this.translationMode = false

    if(event.state){
      if(event.state == 'add'){
        if(event.translations)
          this.templateForm.patchValue({translations : event.translations})
      }

      if(event.state == 'cancel')
        this.translationMode = false
    }

  }

  countTridysPass(){
    const data  = {
      contentTypeId: this.contentTypeId,
      contextId: this.settingsService.contextId$
    }

    this.commentService.progressSpin.emit(true)
    const countTridys = httpsCallable(this.functions, 'info-countTridys');

    countTridys( data ).then((result) => {
      const data:any = result.data;
      this.tridyCount = data['count']
      this.commentService.progressSpin.emit(false)
    })
    .catch((error) => {
      this.commentService.progressSpin.emit(false)
      const message = this.translate.instant("SnackBarConstants.CREATE_FAILED")
      this.commentService.addSnackBar.emit(message)
      this.commentService.addSnackBar.emit(error)
    });
  }

  showTranslatedView(){
    if(this.passLanguages && this.passLanguages.length>1){
      this.translationMode = true
      this.translationDisabled = false
    }else{
      if(!this.passLanguages || this.passLanguages.length ==0 ){
        if(this.contextLanguages && this.contextLanguages.length>1)
          this.translationMode = true

        if(!this.contextLanguages){
          this.translationDisabled = true
          const message = this.translate.instant("SnackBarConstants.NO_GLOBAL_LANGUAGES")
          this.commentService.addSnackBar.emit(message)
        }
        if(this.contextLanguages && this.contextLanguages.length==1){
          this.translationDisabled = true
          const message = this.translate.instant("SnackBarConstants.MORE_GLOBAL_LANGUAGES")
          this.commentService.addSnackBar.emit(message)
        }
      }

      if(this.passLanguages && this.passLanguages.length==1){
        this.translationDisabled = true
        const message = this.translate.instant("SnackBarConstants.MORE_LANGUAGES")
        this.commentService.addSnackBar.emit(message)
      }

      if(this.passLanguages && this.passLanguages.length==0 && this.contextLanguages && this.contextLanguages.length ==0 ){
        this.translationDisabled = true
        const message = this.translate.instant("SnackBarConstants.MORE_LANGUAGES")
        this.commentService.addSnackBar.emit(message)
      }

    }
  }

  closeTranslatedView(){ this.translationMode = false }

  private getInsertIndex(): number {
    const idx = this.getSelectedIndex();
    return idx >= 0 ? idx + 1 : 0;
  }

  private getSelectedIndex(): number {
    if (!this.selectedWidgetId) return -1;
    return this.allWidgets.findIndex(w => w?.id === this.selectedWidgetId);
  }

  private selectWidgetById(id: string | null): void { this.selectedWidgetId = id; }

  private applyTranslationSlice( oldId: string, newId: string, slice: any, nestedIdMap: Record<string, string> = {} ): void {
    if (!slice) return;

    const currentTranslations = this.getActiveTranslations();

    Object.keys(slice).forEach(lang => {
      const langObj = slice[lang];
      if (!langObj) return;

      currentTranslations[lang] ??= {};
      const targetLangObj = currentTranslations[lang];

      Object.keys(langObj).forEach(key => {
        const value = langObj[key];
        const newKey = transformTranslationKey(key, oldId, newId, nestedIdMap);
        if (newKey) 
          targetLangObj[newKey] = value;
      });
    });

    this.setActiveTranslations(currentTranslations);
  }

  private getActiveTranslations(): any { return deepCopy(this.activeTab?.translations || {}); }

  private setActiveTranslations(translations: any): void {
    this.activeTab.translations = deepCopy(translations || {});
    this.templateForm.patchValue({ translations: this.activeTab.translations }, { emitEvent: false });
  }

}
